import script from "./SetupSpendingAnalysisPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./SetupSpendingAnalysisPage.vue?vue&type=script&setup=true&lang=ts"

import "./SetupSpendingAnalysisPage.vue?vue&type=style&index=0&id=8a34d4b0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8a34d4b0"]])

export default __exports__